var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/integrations/integrations.jade
// module id = 260
// module chunks = 0